import React from "react";
import PropTypes from "prop-types";
import { Icon } from "../../atoms/icon";
import styles from "./styles.m.css";
import { Link } from "@quintype/components";
import { get } from "lodash";

function getSectionPath(section, parentSection) {
  let parentSlug = get(parentSection, ["slug"]);
  let sectionSlug = get(section, ["slug"]);
  if (section["section-url"]) {
    return section["section-url"];
  }

  if (parentSection) {
    return `/${parentSlug}/${sectionSlug}`;
  }

  return `/${sectionSlug}`;
}

const CategoryBadgeTextStory = ({ icon = "premium", color = "#2bab64", subSection, config }) => {
  let parentSection = null;
  let parentName = null;
  if (subSection) {
    parentSection = config.sections ? config.sections.find(section => section.id === subSection["parent-id"]) : null;
    parentName = get(parentSection, ["name"]);
  }

  return (
    <div>
      {parentSection && parentName ? (
        <Link
          aria-label={`${"Navigate to "} ${parentName}`}
          href={`${getSectionPath(parentSection)}?pfrom=header-tag`}
          callback={() => {
            if ("ga" in window) {
              window.ga("send", "event", "category-tag", "click", window.location.href);
            }
          }}
        >
          <span className={`${styles["category"]}`} style={{ "--accent-color": color }}>
            <Icon className={styles["category-icon"]} type={icon} />
            <span className={styles["category-name"]}>
              {parentName === "government and politics" ? "government & politics" : parentName}
            </span>
          </span>
        </Link>
      ) : (
        <span className={`${styles["category"]}`} style={{ "--accent-color": color }}>
          <Icon className={styles["category-icon"]} type={icon} />
          <span className={styles["category-name"]}>News</span>
        </span>
      )}
    </div>
  );
};

CategoryBadgeTextStory.propTypes = {
  icon: PropTypes.string,
  color: PropTypes.string,
  config: PropTypes.shape({
    section: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        name: PropTypes.string,
        slug: PropTypes.string
      })
    ),
    "publisher-name": PropTypes.string
  }),
  subSection: PropTypes.shape({
    name: PropTypes.string,
    color: PropTypes.string
  })
};

export { CategoryBadgeTextStory };
